import { useTranslations } from 'next-intl'
import NextLink from 'next/link'
import { Box, Button, Heading, Flex } from '@chakra-ui/react'
import { ContainerBase } from './containers/ContainerBase'

export function Hero() {
  const t = useTranslations()
  return (
    <Box
      bg={'black'}
      py={{ base: '157px', md: '214px' }}
      pb={{ base: '157px', md: '214px', xl: '276px' }}
      overflow={'hidden'}
      position={'relative'}
      // 100% viewport height - header height
      maxHeight={{ base: 'calc(100vh - 54px)', md: 'calc(100vh - 82px)' }}
    >
      <Box
        position={'absolute'}
        zIndex={1}
        as="video"
        h={{ base: '100%', md: 'inherit' }}
        top={{ base: 0, md: '50%' }}
        left={'50%'}
        transform={{
          base: 'translateX(-50%)',
          md: 'translateX(-50%) translateY(-50%)',
        }}
        maxW="inherit"
        mx="auto"
        autoPlay
        muted
        loop
        playsInline
        poster="/img/hero/CompassMining_HomepageHero.png"
      >
        <source
          src="/img/hero/CM_Homepage_HeroVideo.h264.mp4"
          type="video/mp4"
        />
      </Box>
      <ContainerBase
        position={'relative'}
        maxWidth={'1280px'}
        py={0}
        px={4}
        textAlign={'center'}
        zIndex={2}
      >
        <Heading
          as="h1"
          variant="spaceGrotesk"
          fontSize={{
            base: '40px',
            md: '75px',
            xl: '120px',
          }}
          fontWeight={300}
          lineHeight={'73.3%'}
          textAlign="center"
          color={'white'}
          mb={{ base: 2, md: 8 }}
        >
          {t('slogan.title')}
        </Heading>
        <Heading
          as="h3"
          fontSize={{ base: '18px', md: '20px', xl: '24px' }}
          color="whiteAlpha.800"
          fontWeight={300}
          mb={{ base: 2, md: 8 }}
        >
          {t('slogan.description')}
        </Heading>
        <Flex
          gridGap={{ base: 2, md: '27px' }}
          flexWrap="wrap"
          justifyContent="center"
        >
          <NextLink href="/hardware" passHref>
            <Button
              as="a"
              variant="brandGradient"
              mb={{ base: 2, sm: 0 }}
              zIndex={5}
              width={{ base: '200px', md: '150px', xl: '200px' }}
              py="6"
              fontWeight={500}
              letterSpacing={'-0.3px'}
            >
              {t('buttons.buy-now')}
            </Button>
          </NextLink>
          <NextLink href="/hosted-mining" passHref scroll={false}>
            <Button
              as="a"
              variant="outline"
              mb={{ base: 2, sm: 0 }}
              zIndex={5}
              width={{ base: '200px', md: '150px', xl: '200px' }}
              py="6"
              fontWeight={500}
              color={'white'}
              _hover={{
                background: 'whiteAlpha.400',
              }}
              letterSpacing={'-0.3px'}
            >
              {t('buttons.learn-more')}
            </Button>
          </NextLink>
        </Flex>
      </ContainerBase>
    </Box>
  )
}
